var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgStar = function SvgStar(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C12.2841 1.25 12.5438 1.4105 12.6708 1.66459L15.5 7.32299L21.1233 8.2602C21.4004 8.30639 21.6285 8.50358 21.7142 8.77112C21.8 9.03866 21.729 9.33168 21.5303 9.53033L17.3243 13.7364L18.7308 19.8314C18.7961 20.1143 18.6922 20.4096 18.464 20.5893C18.2358 20.7689 17.9244 20.8007 17.6646 20.6708L12 17.8385L6.33543 20.6708C6.07566 20.8007 5.76425 20.7689 5.53606 20.5893C5.30787 20.4096 5.20392 20.1143 5.26923 19.8314L6.67576 13.7364L2.46969 9.53033C2.27103 9.33168 2.20006 9.03866 2.2858 8.77112C2.37153 8.50358 2.5996 8.30639 2.87672 8.2602L8.5 7.32299L11.3292 1.66459C11.4563 1.4105 11.7159 1.25 12 1.25ZM12 3.67705L9.67084 8.33541C9.56353 8.55003 9.36001 8.70035 9.12332 8.7398L4.56088 9.5002L8.03035 12.9697C8.2132 13.1525 8.28896 13.4167 8.23081 13.6686L7.08887 18.617L11.6646 16.3292C11.8758 16.2236 12.1243 16.2236 12.3354 16.3292L16.9112 18.617L15.7692 13.6686C15.7111 13.4167 15.7868 13.1525 15.9697 12.9697L19.4392 9.5002L14.8767 8.7398C14.64 8.70035 14.4365 8.55003 14.3292 8.33541L12 3.67705Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Star.7c730e43d9f7f7230574285cf67f530f.svg";